import httpInstance from '@/utils/http'
const AUTH_BASE_URL = "/api/v1";

/**
 * 商品列表  get
 * @returns 
 */
export const productListAPI = (params) => {
    return httpInstance({
        url:`${AUTH_BASE_URL}/product/list`, 
        params
    })
}


// export function getBannerAPI(params = {}) {
//     // 默认为1 商品为2
//     const { distributionSite = '1' } = params
//     return httpInstance({
//         url: '/home/banner',
//         params: {
//             distributionSite
//         }
//     })
// }

// 获取新鲜好物

export const findNewAPI = () => {
    return httpInstance({
        url: '/home/new'
    })
}

// 获取人气推荐

export const getHotAPI = () => {
    return httpInstance({
        url: '/home/hot'
    })
}

// 获取所有商品模块

export const getGoodsAPI = () => {
    return httpInstance({
        url: '/home/goods'
    })
}
//获取banner图
export const getBannerAPI = () => {
    return httpInstance({
        url: `${AUTH_BASE_URL}/banner/list`,
        method: 'GET',
       
    })
}
//总销售排行
export const getTotalSalesTopAPI = (params) => {
    return httpInstance({
        url: `${AUTH_BASE_URL}/product/totalSalesTop`,
        method: 'GET',
        params
       
    })
}
//总销售排行
export const getYesterdaySalesTopAPI = () => {
    return httpInstance({
        url: `${AUTH_BASE_URL}/product/yesterdaySalesTop`,
        method: 'GET'
    })
}

//获取getSearchAPI
export const getSearchAPI = (params) => {
    return httpInstance({
        url: `${AUTH_BASE_URL}/search`,
        method: 'GET',
        params
    })
}
